module.exports = __webpack_public_path__ + "img/logo_pphclab.eeb54792.jpg";